<div class="map-container">
  
  @if(showStartButton()){
    <div class="start-route-button-container">
      <ci-fab-button 
        class="start-route-button" 
        class-name="ci-btn-primary-outlined" 
        type="button" 
        (click)="startRoute()"
      >
        {{ 'Comenzar ruta' | translate }}
      </ci-fab-button>
      
      <ci-fab-button 
        class="start-route-button" 
        class-name="ci-btn-primary-outlined" 
        type="button" 
        (click)="saveRoute()"
      >
        {{ 'Guardar ruta' | translate }}
      </ci-fab-button>
    </div>
  }
  
  <google-map #map height="100%" width="100%" 
    (mapInitialized)="onMapReady(map)" 
    (mapClick)="setLocation($event)"
    [options]="options"
  >
    @if(detailPoint()){
      <fitur-map-detail-page-markers 
        [map]="map"
        [detailPoint]="detailPoint()" 
      />
    } @else {
      <fitur-map-polylines />
      <fitur-map-markers [map]="map" />
    }
    <map-indication-card />
    <!-- <map-polylines /> -->
    <!-- <map-markers /> -->
    <map-proyected-point />
  </google-map>

  <map-step-navigation />
  <!-- <app-make-payment-button /> -->
    @if(showDevPanel()){
      <dev-panel-map />
    } 
  
</div>

<!-- MAP OPTIONS
    (mapInitialized)="onMapReady()" 
    (mapDragstart)="disableAutoCenter()"
    (zoomChanged)="disableAutoCenter()"
-->
